import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Button } from '../button';
import { Divider } from '../divider';
import { usePaletteColor } from '../theme';
import { ButtonGroup } from './index';
export const SummaryButtonRow = ({ actions }) => {
    const bgcolor = usePaletteColor('primary.dark');
    return (_jsx(ButtonGroup, { fullWidth: true, children: actions.flatMap(({ title, ...props }, index, all) => {
            const leftRadius = index === 0 ? undefined : 0;
            const rightRadius = index === all.length - 1 ? undefined : 0;
            return [
                _jsx(Button, { color: "primary", variant: "contained", sx: {
                        padding: 1,
                        height: 66,
                        borderBottomLeftRadius: leftRadius,
                        borderTopLeftRadius: leftRadius,
                        borderBottomRightRadius: rightRadius,
                        borderTopRightRadius: rightRadius
                    }, ...props, children: title }, `button=${title}`),
                index < all.length - 1 ? (_jsx(Divider, { orientation: "vertical", sx: {
                        padding: '1px',
                        height: '66px',
                        background: bgcolor
                    } })) : null
            ];
        }) }));
};
